export const DEFAULT_MAP_CENTER = {
    lat: 47,
    lng: 2.3488,
};
